<style lang="scss">
  .itemContainer {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    .item {
      animation: 1s loading ease-in-out infinite;
      backface-visibility: hidden;
      background-color: #f8fafb;
      background: linear-gradient(
          100deg,
          #ffffff00 40%,
          white 50%,
          #ffffff00 60%
        )
        #f8fafb;
      background-size: 200% 100%;
      background-position-x: 180%;
      border: 0;
      color: transparent;
      perspective: 1000;
      pointer-events: none;
      transform: translateZ(0);

      &.noAnimation {
        animation: none;
      }

      @keyframes loading {
        to {
          background-position-x: -20%;
        }
      }
    }
  }
</style>

<script>
  export let containerStyles = {};
  export let itemStyles = {};
  export let itemCount = 5;
  export let noAnimation = false;

  const styleObjectToString = (styleObject) =>
    Object.entries(styleObject)
      .map(
        ([key, value]) =>
          `${key.replace(/([A-Z])/g, "-$1").toLowerCase()}: ${value}`,
      )
      .join("; ");
</script>

<div class="itemContainer" style={styleObjectToString(containerStyles)}>
  {#each Array.from({ length: itemCount }) as _}
    <div
      class="item"
      class:noAnimation
      style={styleObjectToString(itemStyles)}
    ></div>
  {/each}
</div>
